// C:\Ava_Local\Ava_API\avaai_dashboard\frontend\src\pages\education\GradeLevelsPage.tsx

import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ThemeContext } from "../../context/ThemeContext";

type Grade = {
  label: string;
  desc: string;
};

export default function GradeLevelsPage() {
  const navigate = useNavigate();
  const { themeColors } = useContext(ThemeContext);
  const [selected, setSelected] = useState<string | null>(null);

  const grades: Grade[] = [
    {
      label: "K-2",
      desc: "Early math basics like counting, simple addition, and subtraction.",
    },
    {
      label: "3-5",
      desc: "Multiplication, division, and stronger number skills.",
    },
    {
      label: "6-8",
      desc: "Advanced arithmetic, fractions, and problem solving.",
    },
    {
      label: "9-12",
      desc: "Higher level math, algebra style thinking, and complex problems.",
    },
  ];

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "40px 20px",
        color: themeColors.text,
        background: themeColors.bg,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
        }}
      >
        {/* Header */}
        <div
          style={{
            borderRadius: "26px",
            padding: "28px",
            marginBottom: "28px",
            background: themeColors.panel,
            border: `1px solid ${themeColors.border}`,
            boxShadow: themeColors.glow,
            backdropFilter: "blur(10px)",
          }}
        >
          <div
            style={{
              fontSize: "13px",
              letterSpacing: "0.22em",
              textTransform: "uppercase",
              color: themeColors.accent2,
              fontWeight: 800,
              marginBottom: "10px",
            }}
          >
            Ava Education
          </div>

          <h1
            style={{
              margin: 0,
              fontSize: "clamp(34px,5vw,56px)",
              lineHeight: 1,
              fontWeight: 900,
              color: themeColors.accent,
              textShadow: themeColors.glow,
            }}
          >
            Choose Grade Level
          </h1>

          <p
            style={{
              marginTop: "14px",
              fontSize: "18px",
              color: themeColors.mutedText,
              maxWidth: "760px",
            }}
          >
            Select a grade range so Ava adjusts explanations, difficulty,
            and practice problems to match the student.
          </p>
        </div>

        {/* Grade Cards */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "20px",
          }}
        >
          {grades.map((g) => {
            const active = selected === g.label;

            return (
              <button
                key={g.label}
                onClick={() => {
                  setSelected(g.label);
                  navigate("/education/flashcards");
                }}
                style={{
                  padding: "26px",
                  borderRadius: "18px",
                  border: active
                    ? `1px solid ${themeColors.accent}`
                    : `1px solid ${themeColors.border}`,
                  background: themeColors.cardBg,
                  color: themeColors.text,
                  cursor: "pointer",
                  textAlign: "left",
                  transition: "all .18s ease",
                  boxShadow: active
                    ? themeColors.glow
                    : "0 10px 26px rgba(0,0,0,0.35)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-4px)";
                  e.currentTarget.style.boxShadow =
                    `0 16px 38px rgba(0,0,0,0.45), ${themeColors.glow}`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    active
                      ? themeColors.glow
                      : "0 10px 26px rgba(0,0,0,0.35)";
                }}
              >
                <div
                  style={{
                    fontSize: "30px",
                    fontWeight: 900,
                    marginBottom: "10px",
                    color: themeColors.accent,
                  }}
                >
                  {g.label}
                </div>

                <div
                  style={{
                    fontSize: "15px",
                    lineHeight: 1.5,
                    color: themeColors.mutedText,
                  }}
                >
                  {g.desc}
                </div>
              </button>
            );
          })}
        </div>

        {/* Back button */}
        <div
          style={{
            marginTop: "36px",
          }}
        >
          <button
            onClick={() => navigate("/education")}
            style={{
              padding: "12px 18px",
              borderRadius: "10px",
              border: `1px solid ${themeColors.border}`,
              background: themeColors.buttonBg,
              color: themeColors.text,
              cursor: "pointer",
            }}
          >
            ← Back to Education
          </button>
        </div>
      </div>
    </div>
  );
}